module.exports = __webpack_public_path__ + "img/online-shopping.fd6acbc9.jpg";